<template lang="pug">
  div(:style="!playing && 'visibility: hidden;'")
    Lottie(:options="lottieOptions" @animCreated="handleCreated" @complete="handleStep" :width="70" :height="70")
</template>

<script>
  import * as webinarLottie from '../lottie/webinar.json';

  export default {
    data () {
      return {
        nextStep: 'intro',
        playing: false
      };
    },

    created () {
      this.lottieOptions = {
        animationData: webinarLottie.default,
        autoplay: false,
        loop: false
      };
    },

    methods: {
      handleCreated (anim) {
        this.anim = anim;
      },

      handleStep (anim) {
        switch (this.nextStep) {
          case 'intro':
            anim.playSegments([0, 71], true);
            this.anim.setSpeed(1.3);
            this.nextStep = 'idle';
            break;

          case 'idle':
            setTimeout(() => anim.playSegments([72, 260]), 500);
            this.anim.setSpeed(1.5);
            break;
        }
      },

      play () {
        if (this.playing) return;
        this.playing = true;
        this.nextStep = 'intro';
        this.handleStep(this.anim);
      },

      stop () {
        if (!this.playing) return;
        this.playing = false;
        this.anim.goToAndStop(0, true);
      }
    }
  };
</script>